import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { ArticleCard } from 'components/Article/ArticleCard/ArticleCard';
import { DividingLine } from 'components/DividingLine/DividingLine';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { OuterBox } from 'components/OuterBox/OuterBox';
import { Pagination } from 'components/Pagination/Pagination';
import { Separator } from 'components/Separator/Separator';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { TENANT_ID } from 'global/constants';
import 'global/style/pages.sass';

import { getTenantId } from 'utils/tenantUtil';

export const ArticleOverview = ({
  data: articleData,
  loading,
  setPaginationVars,
  totalPages,
  headline,
  currentPage,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const lastArticleDate =
    articleData &&
    articleData[articleData.length - 1] &&
    articleData[articleData.length - 1].creationDate;

  const firstArticleDate = articleData[0]?.creationDate;
  const articlesNumber = articleData?.length;

  return (
    <>
      <OuterBox>
        {loading && <LoadingIndicator />}
        {!loading && (
          <>
            <SubTitle text={headline} notFramed />
            <Separator color={getTenantId() === TENANT_ID.AVA ? 'homepage' : 'secondary'} />
            <div className="article-cards">
              {articleData.map((data, index) => (
                <React.Fragment key={data.id}>
                  <ArticleCard article={data} />
                  {index < articleData.length - 1 && <DividingLine />}
                </React.Fragment>
              ))}
            </div>
          </>
        )}
      </OuterBox>
      <Pagination
        selectVarsForPag={setPaginationVars}
        lastItemDate={lastArticleDate}
        firstItemDate={firstArticleDate}
        totalPages={totalPages}
        itemsNumber={articlesNumber}
        currentPage={currentPage}
        text="Fachbeiträge pro Seite"
      />
    </>
  );
};

ArticleOverview.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  setPaginationVars: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  headline: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
};
